import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["pendiente", "en_revision", "aprobada", "rechazada"];
const COLORS = {
  pendiente: "bg-orange-500/15 text-orange-500 border-orange-500/30",
  en_revision: "bg-blue-500/15 text-blue-500 border-blue-500/30",
  aprobada: "bg-green-500/15 text-green-500 border-green-500/30",
  rechazada: "bg-red-500/15 text-red-500 border-red-500/30",
};

export default function AdminQuotes() {
  const [quotes, setQuotes] = useState([]);
  const load = () => api.get("/quotes").then((r) => setQuotes(r.data));
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    await api.put(`/quotes/${id}/status`, { status });
    toast.success("Estado actualizado");
    load();
  };

  return (
    <div>
      <h1 className="font-display font-black text-3xl tracking-tight mb-6">COTIZACIONES</h1>
      {quotes.length === 0 ? (
        <div className="py-16 text-center text-muted-foreground">Aún no hay cotizaciones.</div>
      ) : (
        <div className="space-y-3" data-testid="admin-quotes">
          {quotes.map((q) => (
            <div key={q.id} className="border border-border p-5">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <div className="font-display font-bold text-xl tracking-tight">{q.machinery_name}</div>
                  <div className="text-sm text-muted-foreground">{q.name} · {q.email} · {q.phone || "sin teléfono"}{q.company ? ` · ${q.company}` : ""}</div>
                  <div className="text-sm mt-1">{q.listing_type === "venta" ? "Compra" : "Alquiler"}{q.start_date ? ` · ${q.start_date}${q.end_date ? ` → ${q.end_date}` : ""}` : ""}</div>
                  {q.message && <div className="text-sm text-muted-foreground mt-2 italic">"{q.message}"</div>}
                  <div className="text-xs text-muted-foreground mt-2">{new Date(q.created_at).toLocaleString()}</div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <span className={`text-xs font-semibold px-3 py-1 border ${COLORS[q.status]}`}>{q.status.replace("_", " ").toUpperCase()}</span>
                  <select value={q.status} onChange={(e) => changeStatus(q.id, e.target.value)} data-testid={`quote-status-${q.id}`}
                    className="h-9 px-2 bg-background border border-input text-sm">
                    {STATUSES.map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
                  </select>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
